import { initSelect2Modal, hideModalOn } from './select2_modal'

initSelect2Modal({
  modalId: 'add-providers-modal',
  selectId: 'provider_ids',
  placeholder: 'Search providers…',
})

hideModalOn('closeAddModal')
hideModalOn('closeRemoveModal')
